export default __webpack_public_path__ + "static/media/spark_23.c9ce90c9.png";